module.exports = __webpack_public_path__ + "static/steve-sperandeo-2728762e6f0fb885ddb5e320442025fb.png";